<template>

</template>

<script>
import jwt_decode from 'jwt-decode';
import axios from 'axios';
import Spinner from '../../vendor/Spinner.vue';
// Use /dist/ version to avoid issue with: Unexpected token: punc (() in tweet/index.js (... operator)
import Tweet from 'vue-tweet-embed/dist/tweet';

const typeformEmbed = require('@typeform/embed');

// import * as _tweetResponse from './mock-tweet-response.json';

export default {
  name: 'TweetSectionBase',

  components: {
    Spinner,
    Tweet
  },

  props: {
    tweetSequence: Object
  },  

  data: function () {
    return {
      tweetStates: {
        'default': 'default',
        'processing': 'processing',
        'success': 'success'
      },
      currentState: null,
      lastTokenCheck: null,
      isLoading: false,
      successResult: null
    };
  },

  mounted () {
    // Ping Twitter function to wake it up, ready for Twitter stuff
    axios.get('/api/TwitterPing');

    this.redoTokenCheck();    

    this.currentState = this.tweetStates.default;

    // Testing:
    // this.currentState = this.tweetStates.processing;

    // this.successResult = _tweetResponse;
    // this.currentState = this.tweetStates.success;
  },

  computed: {
    isLoggedIn () {
      if (this.lastTokenCheck) {
        return this.$jwt.hasToken();
      }
      return false;
    },

    twitterProfile () {
      let token = this.$jwt.getToken();
      let payload = jwt_decode(token);
      let profile = payload.profile;
      // console.log('Profile: ', profile);
      return profile;
    }
  },

  methods: {
    authenticate () {
      this.$appInsights.trackEvent('User chose to authenticate with Twitter');
      this.$ga.event('"Sign in with Twitter" button', 'click', 'Create > Tweet section');

      const vm = this;
      vm.isLoading = true;
      this.$auth.authenticate('twitter').then(function (authResponse) {
        // Execute application logic after successful social authentication
        console.log('Authenticated with Twitter...', authResponse);        
        var token = authResponse.data.token;
        if (token) {
          vm.redoTokenCheck();
          vm.$appInsights.trackEvent('Authenticated with Twitter. Got a token');
          vm.$ga.event('Authenticated with Twitter', 'Got a token', 'Create > Tweet section');
          // var payload = jwt_decode(token);
          // console.log(payload);
          // var profile = payload.profile;
          // var name = profile.userDTO.name;
          // alert('Hello ' + name + '!');
        } else {
          console.error('Expected a token, but none found. ', authResponse.data);
          vm.$appInsights.trackEvent('Authenticated with Twitter. *No* token found');
          vm.$ga.event('Authenticated with Twitter', '*No* token found', 'Create > Tweet section');
          // TODO: Show error modal
          vm.logOut();
        }
        vm.isLoading = false;
      }, function (errorResponse) {
        console.log('Authentication with Twitter failed', errorResponse);
        vm.$appInsights.trackEvent('Authentication with Twitter failed', { errorResponse: errorResponse });
        vm.$ga.exception('Authentication with Twitter failed');
        vm.isLoading = false;
      })
    },

    submit () {      
      // Send the sequence to API and show loading animation
      console.log('Submitting tweetSequence:' , JSON.stringify(this.tweetSequence));
      this.$appInsights.trackEvent('User chose to submit tweet sequence');
      this.$ga.event('"Submit" button', 'click', 'Create > Tweet section');

      let token = this.$jwt.getToken();
      this.currentState = this.tweetStates.processing;
      // this.isLoading = true;

      // TODO: Convert to use (response) => format to avoid using 'vm' instead of this.
      axios.post('/api/PostTwitterSequence', {
          token: token,
          sequence: this.tweetSequence
        })
        .then((response) => {
          console.log(response);
          this.successResult = response.data;
          this.currentState = this.tweetStates.success;
          // this.isLoading = false;          
          this.$appInsights.trackEvent('Success posting tweet sequence to server');
          this.$ga.event('Posting tweet sequence', 'success', 'Create > Tweet section');
        })
        .catch((error) => {
          console.error(error);
          this.currentState = this.tweetStates.default;
          // this.isLoading = false;
          
          this.$snackbar.open({
              message: 'Oops, something went wrong. Please try again.',
              type: 'is-warning',
              position: 'is-top',
              indefinite: false
          });

          this.$appInsights.trackEvent('Error posting tweet sequence to server!', { error: error });
          this.$ga.exception(`Error posting tweet sequence to server - Error: ${error}`);
        });
    },

    logOut () {
      this.$localStorage.remove('vue-authenticate.vueauth_token');
      this.redoTokenCheck();
      this.$appInsights.trackEvent('User chose to log out of Twitter auth');
      this.$ga.event('"Log out" button', 'click', 'Create > Tweet section');
    },

    redoTokenCheck () {
      this.lastTokenCheck = new Date();
    },

    goToUploadStep () {
      this.$emit('back-to-upload');
    },

    showFeedbackModal () {
      const vm = this;

      typeformEmbed.makePopup('https://ed326.typeform.com/to/bMWooq', {
        mode: 'popup',
        autoOpen: true,
        onSubmit: function () {
          console.log('Typeform successfully submitted');
          vm.$appInsights.trackEvent('Create > Tweet section > Typeform successfully submitted');
          vm.$ga.event('Typeform', 'submitted', 'Create > Tweet section');
        }        
      });
    }
  }
  
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/create/TweetSectionBase.vue